import { createStore, applyMiddleware, combineReducers } from 'redux';
import ReduxThunk from 'redux-thunk';
// import reducer from './reducer';
import cardReducer from './cards/reducer';
import sidebarReducer from './sidebar/reducer';
import searchReducer from './search/reducer';
import monsterReducer from './monster/reducer';

const rootReducer = combineReducers({
    cards: cardReducer,
    sidebar: sidebarReducer,
    search: searchReducer,
    monster: monsterReducer
})

const store = createStore(rootReducer, applyMiddleware(ReduxThunk))

export default store